export const adminNotepadPlusCleanUpTool = (currentContentEditorRef) => {
    return {
        name: "format-code-block",
        tooltip: "Clean up spacing",
        exec: function(e) {
            let $ = window.jQuery
            let editor = $(currentContentEditorRef).data("kendoEditor");
            let updatedContent = editor.value();

            // Replace all <div> with <p> and </div> with </p>
            let regex = /<div(\s[^>]*)?>/g;
            updatedContent = updatedContent.replace(regex, "<p>")
            regex = /<\/div\s*>/g;
            updatedContent = updatedContent.replace(regex, "</p>");
            
            // Remove all <br/> tags that are before </p> tags
            regex = /<br\s*\/>\s*(?=<\/p>)/g;
            updatedContent = updatedContent.replace(regex, '');

            // Remove all a nbsp; wrapped in <p> tags
            regex = /<p[^>]*>(&nbsp;)+<\/p>/gi
            updatedContent = updatedContent.replace(regex, "");
            
            // Remove all &nbsp; from the content
            regex = /(&nbsp;)/gi
            updatedContent = updatedContent.replace(regex, "");

            // Set the updated content back to the editor
            editor.value(updatedContent);
        }
    }
}